import { ToastService } from "@shared/lib/services";
import { IBriefInfluencerPurchaseStatusRequest } from "@shared/lib/types/brief";
import { IBriefInfluencerV2 } from "@shared/lib/types/briefInfluencerV2";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { BRIEF_INFLUENCER_V2_PURCHASE_STATUS_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";

const EMPTY_PURCHASE_STATUS: {
  status: "failed" | "success";
  reason: string;
  briefInfluencer: IBriefInfluencerV2;
}[] = [];

export function useGetBriefInfluencerPurchaseStatus(
  open: boolean,
  params: IBriefInfluencerPurchaseStatusRequest
) {
  const { data, isFetching, isError, error, isSuccess } = useQuery<{
    data: {
      nextActionToTake: string;
      result: {
        status: "failed" | "success";
        reason: string;
        briefInfluencer: IBriefInfluencerV2;
      }[];
    };
  }>({
    queryKey: [...BRIEF_INFLUENCER_V2_PURCHASE_STATUS_QUERY_KEY, params],
    queryFn: () =>
      BriefService.getBriefInfluencersPurchaseStatus({ ...params }),
    enabled: open,
    staleTime: 0
  });

  const errorMessage = isError && (error as Error)?.message;
  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    purchaseStatus: data?.data?.result || EMPTY_PURCHASE_STATUS,
    isFetching,
    isSuccess
  };
}

